import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import styles from "./LocationDisplay.module.css";

interface LocationDisplayProps {
  location: {
    country: string;
    countryThumbnail?: string;
    province?: string;
    district?: string;
  };
  variant?: "mobile" | "desktop";
}

const LocationDisplay: React.FC<LocationDisplayProps> = ({
  location,
  variant = "desktop",
}) => {
  const LocationIcon =
    location.country === "" ? (
      <LocationOnIcon className={styles.locationIcon} />
    ) : (
      <img
        src={location.countryThumbnail}
        alt="Country Thumbnail"
        className={styles.countryThumbnail}
      />
    );

  if (variant === "desktop") {
    return (
      <div className={styles.desktopContainer}>
        {LocationIcon}
        <div className={styles.textContainer}>
          {location.country === "" ? (
            <>
              <div className={styles.locationText}>
                Averigua cuánto nos tardaremos
              </div>
              <div className={styles.location}>¿Dónde recibirás tu pedido?</div>
            </>
          ) : (
            <>
              <div className={styles.locationText}>Envíos a:</div>
              <div className={styles.location}>
                {location.province}, {location.district}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.mobileContainer}>
      {LocationIcon}
      {location.country === "" ? (
        <span className={styles.locationText}>¿Dónde recibirás tu pedido?</span>
      ) : (
        <>
          <span className={styles.locationText}>Envíos a:</span>
          <span className={styles.location}>
            {location.province}, {location.district}
          </span>
        </>
      )}
    </div>
  );
};

export default LocationDisplay;
